import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface Props {
  content: string;
  isAnalysing: boolean;
  error: string | null;
}

export default function MatchAnalysisTab({ content, isAnalysing, error }: Props) {
  const isEmpty = !content && !isAnalysing;

  return (
    <div className="h-full overflow-y-auto py-6">
      {error && (
        <div
          role="alert"
          className="mb-4 px-3 py-2 rounded bg-red-50 dark:bg-red-950 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 text-sm"
        >
          {error}
        </div>
      )}

      {isEmpty ? (
        <p className="text-slate-500 dark:text-slate-400 italic">
          No analysis yet. Click &lsquo;Analyse&rsquo; to generate one.
        </p>
      ) : (
        <div
          className={`prose prose-slate dark:prose-invert max-w-none${isAnalysing ? " opacity-70" : ""}`}
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
      )}
    </div>
  );
}
